"use client";

import React from "react";
import { Rocket, Briefcase, TrendingUp, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
const audiences = [{
  id: "founders",
  title: "Precision Diagnosis",
  description: "Leverage advanced diagnostic protocols to identify the root cause of your symptoms with speed and clinical accuracy.",
  linkText: "Explore Treatments",
  linkUrl: "/TreatmentsPage",
  iconName: "Rocket"
}, {
  id: "operations",
  title: "Specialized Expertise",
  description: "Access a network of board-certified specialists dedicated to crafting a medical strategy unique to your physiological needs.",
  linkText: "Learn Our Approach",
  linkUrl: "/OurStoryPage",
  iconName: "Briefcase"
}, {
  id: "sales",
  title: "Sustained Vitality",
  description: "Experience measurable improvements in your long-term health through data-driven tracking and proactive wellness adjustments.",
  linkText: "View Health Insights",
  linkUrl: "/HealthInsightsPage",
  iconName: "TrendingUp"
}];
const iconMap: Record<string, React.ElementType> = {
  Rocket,
  Briefcase,
  TrendingUp
};
export default function WhoWeHelp() {
  return <section data-section-id="150295" id="benefits-of-service-name" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-primary tracking-tight">
            The Benefits of Personalized Care
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {audiences.map((audience, i) => {
          const IconComponent = iconMap[audience.iconName];
          return <div data-index={i} key={audience.id} className="h-full">
                <Card className="h-full flex flex-col bg-card border-none shadow-xl rounded-3xl transition-transform duration-[300ms] ease-out hover:-translate-y-2">
                  <CardHeader className="pb-4">
                    {IconComponent && <IconComponent className="size-12 text-accent stroke-[1.25] mb-4" />}
                    <CardTitle className="text-3xl text-primary font-serif font-semibold leading-tight">
                      {audience.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow pb-6">
                    <p className="text-lg font-sans text-foreground/70 leading-relaxed">
                      {audience.description}
                    </p>
                  </CardContent>
                  <CardFooter className="pt-0 mt-auto">
                    <Link to={audience.linkUrl} className="inline-flex items-center gap-2 text-accent font-sans font-bold hover:text-accent/80 transition-colors group">
                      {audience.linkText}
                      <ArrowRight className="size-5 transition-transform group-hover:translate-x-1" />
                    </Link>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}